import toast from 'react-hot-toast';
import { Document, Page } from 'react-pdf';

const Modal = ({ isOpen, onClose, file }) => {
  if (!isOpen || !file) return null;

  return (
    <div className="bg-black fixed inset-0 z-50 flex items-center justify-center bg-opacity-75">
      <div className="relative max-h-[90vh] w-full max-w-4xl overflow-hidden rounded-md bg-white shadow-lg dark:bg-navy-700">
        <button
          onClick={onClose}
          className="absolute right-2 top-2 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-brand-500 text-3xl text-white "
        >
          &times;
        </button>
        <div className="max-h-[90vh] w-full overflow-auto p-1">
          {file.type === 'image' && (
            <img
              src={file.src}
              alt="Preview"
              className="mx-auto max-h-full max-w-full rounded-md object-contain"
            />
          )}
          {file.type === 'pdf' && (
            <Document file={file.src} className="flex justify-center">
              <Page pageNumber={1} />
            </Document>
          )}

          {file.type === 'video' && (
            <div className="relative">
              <video
                controls
                className="pointer-events-auto max-h-[90vh] w-full rounded-md"
              >
                <source src={file.src} />
                Your browser does not support the video tag.
              </video>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
